/** Valid fields for the suggest_edit tool, matching the backend Zod schema */
const VALID_SUGGEST_EDIT_FIELDS = new Set([
  'label',
  'companyName',
  'businessModelAndValueProp',
  'capabilitiesAndAssets',
  'hardConstraints',
  'goals',
  'productType',
  'name',
  'age',
  'occupation',
])

interface ToolCallInput {
  name: string
  args: Record<string, string>
}

interface ValidationResult {
  valid: boolean
  error?: string
}

/** Validate a tool call's args match expected schema */
export function validateToolCall(tc: ToolCallInput): ValidationResult {
  if (tc.name === 'suggest_edit') {
    if (!tc.args.field) return { valid: false, error: 'Missing field' }
    if (!VALID_SUGGEST_EDIT_FIELDS.has(tc.args.field)) {
      return { valid: false, error: `Invalid field: ${tc.args.field}` }
    }
    if (tc.args.value === undefined || tc.args.value === null) {
      return { valid: false, error: 'Missing value' }
    }
    return { valid: true }
  }

  // generate_suggestions is executed server-side — it should not appear as a frontend tool call
  return { valid: false, error: `Unknown tool: ${tc.name}` }
}

/** Filter and validate tool calls from API response, logging any rejected ones */
export function filterValidToolCalls(
  toolCalls: ToolCallInput[]
): { name: string; args: Record<string, string> }[] {
  return toolCalls.filter((tc) => {
    const result = validateToolCall(tc)
    if (!result.valid) {
      console.warn(`[NodeChat] Rejected malformed tool call "${tc.name}":`, result.error, tc.args)
    }
    return result.valid
  })
}
